<template>
  <div>
    <div class="row">
      <div :class="dataId ? 'col' : 'col-sm-12'">
        <Loading v-if="loading" />
      </div>
    </div>
    <div class="col-sm-12" v-if="dataId">
      <h3 class="my-3">Proyectos</h3>
      <select
        v-model="projectId"
        class="form-select border-secondary"
        aria-label="Seleccionar Proyecto"
        @change="setTreeData"
        v-if="projectList"
      >
        <template
          v-for="project of projectList"
          :key="`projectList${project.id}`"
        >
          <option :value="project.id">{{ project.name }}</option>
        </template>
      </select>
      <DataTableAssignRole
        url="roles/roles_by_project"
        edit-url="edit-role-form"
        :user-id="dataId"
        :project-id="projectId"
        :folders="getFolders"
        :folder-list="getFolderList"
        v-if="getFolderStructureId"
        :key="'datatable-project-' + projectId"
      />
    </div>
    <div class="d-flex justify-content-end">
      <button
        type="button"
        @click="saveData()"
        class="btn btn-primary"
        :disabled="validateData()"
      >
        Guardar
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Loading from "@/components/Loading.vue";
import DataTableAssignRole from "@/components/DataTableAssignRole.vue";

export default {
  name: "users-assign-roles",
  components: { Loading, DataTableAssignRole },
  emits: ["setData", "setBreadcrumb"],
  props: {
    dataId: { default: null },
  },
  data() {
    return {
      breadcrumb: [{ text: "Usuarios", link: { name: "users" } }],
      form: { name: null, description: null },
      currentName: "",
      folders: [],
      folderList: [],
      projectList: [],
      projectId: null,
      projects: [],
      selectedItems: [],
      componentKey: 0,
      loading: false,
    };
  },
  created() {
    if (this.dataId) {
      this.setData();
      this.breadcrumb.push({ text: "Asignar roles", link: { name: "roles" } });
    }
    this.$emit("setBreadcrumb", this.breadcrumb);
  },
  methods: {
    setData(dataId) {
      let app = this;
      this.axios
        .get(`roles/${dataId ? dataId : this.dataId}`)
        .then((result) => {
          app.form = result.data.body;
          app.currentName = app.form.name;
          app.componentKey += 1;
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios
        .get(`projects`)
        .then((result) => {
          app.projectList = result.data.body.data;
          app.projectId = app.projectList[0].id;
          app.setTreeData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setTreeData() {
      let app = this;
      this.axios
        .get(`folder_structures/${this.getFolderStructureId}/folders`)
        .then((result) => {
          // app.form = result.data.body
          app.folders = result.data.body;
          app.currentName = app.form.name;
          app.componentKey += 1;
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios
        .get(`folder_structures/${this.getFolderStructureId}/list_folders`)
        .then((result) => {
          app.folderList = result.data.body;
          app.componentKey += 1;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveData() {
      let app = this;
      this.loading = true;
      if (this.dataId) {
        this.axios
          .put(`roles/${this.dataId}`, {
            role: this.form,
          })
          .then(() => {
            app.loading = false;
            app.$router
              .push({
                name: "roles",
                params: { alertMsg: "Guardado correcto!" },
              })
              .catch();
          })
          .catch((error) => {
            console.log(error);
            app.loading = false;
          });
      } else {
        this.axios
          .post("roles", { role: this.form })
          .then((result) => {
            app.loading = false;
            app.$router
              .push({
                name: "edit-role-form",
                params: {
                  dataId: result.data.body.id,
                  alertMsg: "Guardado correcto!",
                },
              })
              .catch();
            app.setData(result.data.body.id);
          })
          .catch((error) => {
            console.log(error);
            app.loading = false;
          });
      }
    },
    validateData() {
      if (this.form.name && this.form.description) return false;
      return true;
    },
    validateDataMessage(field) {
      switch (field) {
        case "name":
          if (!this.form.name) return "Debe ingresar un nombre";
          break;
        case "description":
          if (!this.form.description) return "Debe ingresar una descripción";
          break;
      }
    },
    buildUrl() {
      return `folder_structures/${this.getFolderStructureId}/list_folders_in_roles`;
    },
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
    getFolderList() {
      return this.folderList;
    },
    getFolders() {
      return this.folders;
    },
    getFolderStructureId() {
      if (this.projectList && this.projectId) {
        let folderStructureId = this.projectList.find(
          (find) => find.id == this.projectId
        );
        return folderStructureId.folder_structure_id;
      }
      return null;
    },
  },
};
</script>
